import React, { useEffect } from 'react';

import { page } from "../config/base";
import { usePop } from '@randajan/jet-react/dom/modal';


export const usePagePop = (hash, children) => {
  const [ pageHash ] = page.use(["hash", hash]);
  const pop = usePop({
    children,
    onUp:_=>pageHash.set("", "up"),
    onDown:_=>{ pageHash.remove(); }
  });

  const status = pageHash.get();

  useEffect(_=>{
    if (status) { pop.up(); } else { pop.down(); }
  }, [status]);

  return pop;
}